import React, {useEffect} from 'react';
import {IonToast} from "@ionic/react";
import {useToastStore} from "../../redux/toast";
import './AppToast.css';

const AppToast: React.FC = () => {
    const toastStore = useToastStore();
    const {isOpen, header, message, color, buttons, duration, generation, clear} = toastStore;

    // Clear stale toast state on mount, and reset atomically on dismiss. Using the
    // single `clear` action (rather than separate setters) guarantees `isOpen`
    // flips false in the same update the fields are cleared, so an empty
    // "info"-coloured toast can never be rendered mid-reset.
    useEffect(() => {
        clear();
    }, [])

    // Keyed by show generation: a second toast shown while the first is still
    // open remounts the overlay, so it gets its own dismiss timer instead of
    // inheriting (and being cut short by) the first toast's. The dismiss passes
    // its own generation so a late dismiss from the replaced toast is ignored.
    return (
        <IonToast
            key={generation}
            cssClass={'app-toast'}
            isOpen={isOpen}
            position={'top'}
            header={header}
            message={message}
            color={color}
            buttons={buttons}
            duration={duration}
            onDidDismiss={() => clear(generation)}
        />
    )
};

export default AppToast;
